<template>
  <div class="changeInput">
    <el-form :model="changeForm" :rules="changeRules" ref="ruleForm" class="demo-ruleForm" :status-icon="true"
             :show-message="false">
      <el-form-item prop="address">
        <div class="one">
          <gmap-autocomplete
            :value="changeForm.address"
            placeholder="Address"
            @place_changed="setPlace"
            :options="{
          componentRestrictions:{country: ['CA']},
          fields:['place_id','geometry','name','address_components']
        }"
          >
          </gmap-autocomplete>
        </div>
      </el-form-item>
      <el-form-item prop="abs">
        <div class="two">
          <el-input v-model="changeForm.abs" placeholder="Apt/Unit/Suite"></el-input>
        </div>
      </el-form-item>
      <div class="three">
        <div class="left">
          <el-form-item prop="city">
            <el-input v-model="changeForm.city" placeholder="City" id="city"></el-input>
          </el-form-item>
        </div>
        <div class="middle">
          <el-form-item prop="province">
            <el-select v-model="changeForm.province">
              <el-option
                v-for="item in changeForm.options"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="rights">
          <el-form-item prop="postcode">
            <el-input v-model="changeForm.postcode" placeholder="Postal Code"></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import {getAllProvice} from "@/api/tasks";
import {helpers} from "gmap-vue";

export default {
  name: "composeInput",
  data() {
    return {
      changeForm: {
        address: "",
        abs: "",
        city: "",
        province: 'ON',
        postcode: '',
        options: []
      },
      changeRules: {
        address: [
          {required: true, message: '', trigger: ['blur', 'change']}
        ],
        city: [
          {required: true, message: '', trigger: ['blur', 'change']}
        ],
        postcode: [
          {required: true, message: '', trigger: ['blur', 'change']}
        ],

      },
      formValidate: '',
      autocomplete: '',
    }
  },
  mounted() {
    this.init()
  },
  destroyed() {
    if (document.getElementById('googleMap')) {
      document.body.removeChild(document.getElementById('googleMap'))
    }
  },
  methods: {
    setPlace(place) {
      if (!place?.geometry) return;
      // this.changeForm.address = place.name;
      this.$set(this.changeForm, 'address', place.name)
      for (const component of place.address_components) {
        const componentType = component.types[0];
        switch (componentType) {
          // case "street_number": {
          //   address1 = `${component.long_name} ${address1}`;
          //   break;s
          // }
          // case "route": {
          //   address1 += component.short_name;
          //   break;
          // }
          case "postal_code": {
            this.$set(this.changeForm, 'postcode', component.long_name)
            break;
          }
          case "administrative_area_level_1": {
            this.$set(this.changeForm, 'province', component.short_name)
            break;
          }
          case "postal_code_prefix": {
            this.$set(this.changeForm, 'postcode', component.long_name)
            break;
          }
          case "locality":
            this.changeForm.city = component.long_name;
            break;
          // case "": {
          //   document.querySelector("#state").value = component.short_name;
          //   break;
          // }
        }
      }
    },
    init() {
      getAllProvice().then(res => {
        this.changeForm.options = res.data.province
      })
    },
    validateForm() {
      let flag = false
      this.$refs['ruleForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    validateClear() {
      this.$refs['ruleForm'].resetFields()
    },
    getAllAddress() {
    },
  }
}
</script>

<style scoped lang="less">
.changeInput {
  width: 100%;

  /deep/ .el-form {
    //display: flex;
    width: 100%;
  }

  .one {
    position: relative;

    /deep/ div :focus {
      outline: none;
      border: 1px solid #E95646 !important;
      border-radius: 16px 16px 0px 0px;
    }

    /deep/ .el-input__inner {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }

    /deep/ .pac-target-input {
      width: 100%;
      box-sizing: border-box;
      padding: 0 0 0 16px;
      height: 32px;
      border-width: 1px;
      border: 1px solid #E0E0E0;
      border-radius: 16px 16px 0px 0px;
    }

    /deep/ .pac-target-input::-webkit-input-placeholder {
      color: #aab2bd;
    }

    /deep/ .pac-target-input:focus {
      border: 1px solid #E95646 !important;
      border-radius: 16px 16px 0px 0px;
    }
  }

  .two {
    /deep/ .el-input__inner {
      border-radius: 0;
      border-bottom: none;
      border-top: none;
    }
  }

  .three {
    display: flex;
    margin-top: -2px;

    .left {
      //flex:5;
      /deep/ .el-input__inner {
        border-bottom-right-radius: 0;
      }

      width: 15vw;
    }

    .middle {
      //flex:1;
      /deep/ .el-input__inner {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
        border-left: none;
      }
    }

    .rights {
      //flex:5;
      /deep/ .el-input__inner {
        border-bottom-left-radius: 0;
      }

      width: 15vw;
    }

    /deep/ .el-input__inner {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
}
</style>
